import React from "react";

import { apiKeys } from "../../app/services/apiKeys";

type ReCaptchaProps = { apiKey?: string };

export const ReCaptcha = (props: ReCaptchaProps) => {
  const { apiKey = apiKeys.value.reCaptcha } = props;

  React.useEffect(() => {
    const id = "ReCaptcha";

    if (!document.getElementById(id)) {
      const script = document.createElement("script");
      script.async = true;
      script.id = id;
      script.src = `https://www.google.com/recaptcha/api.js?render=${apiKey}`;
      document.head.insertBefore(script, document.head.childNodes[0]);
    }

    document.body.dataset.reCaptchaBadgeVisibility = "visible";
    return () => {
      delete document.body.dataset.reCaptchaBadgeVisibility;
    };
  }, [apiKey]);

  return null;
};
